<div class="modal--generic">
  <h1 class="modal__header">{{ data.title }}</h1>
  <div class="modal__body" [innerHtml]="data.body | safeHtml"></div>
  <div *ngIf="data.actions" class="modal__actions modal__actions--inline">
    <button
      *ngFor="let action of data.actions; let i = index"
      class="button button--blue button--primary modal__button"
      style="margin-right: 1em"
      (click)="handle(i)"
    >
      {{ action.text }}
    </button>
  </div>
</div>
